import { site_origin } from "../blog/prerender_head"

/**
 * Canonical URL for the current browser path, matching `prerender_head` / `ogUrl` rules
 * (home uses trailing slash; other paths have no trailing slash).
 */
export function canonical_url_for_location_path(location: string): string {
  const origin = site_origin().replace(/\/$/, "")
  const path = location.split("?")[0].replace(/\/$/, "") || "/"
  if (path === "/") {
    return `${origin}/`
  }
  return `${origin}${path}`
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("canonical_url_for_location_path", () => {
    it("strips query string and normalizes trailing slash for home", () => {
      expect(canonical_url_for_location_path("/?x=1")).toBe(canonical_url_for_location_path("/"))
    })

    it("does not append trailing slash for non-root paths", () => {
      const blog = canonical_url_for_location_path("/blog")
      const post = canonical_url_for_location_path("/blog/foo")
      expect(blog.endsWith("/blog")).toBe(true)
      expect(blog.endsWith("/blog/")).toBe(false)
      expect(post.endsWith("/blog/foo")).toBe(true)
    })
  })
}
